import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

interface Props {
  isFullPage?: boolean
}

export const StyledFlex = styled(Flex)<Props>`
  ${({theme, isFullPage}) => theme.mediaQueries.minWidthMedia.desktop`
    display: ${isFullPage ? "none" : "flex"};
  `}
`
